import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DurationPipe } from './duration.pipe';
import { FillPipe } from './fill.pipe';

@NgModule({
  declarations: [DurationPipe, FillPipe],
  exports: [DurationPipe, FillPipe],
  imports: [CommonModule],
})
export class PipesModule {}
